<app-page-body>
  <!-- header -->
  <app-page-header
    [title]="title | translate"
    [isForm]="true"
    (onBack)="onClose()"
    (onPrint)="onPrint()"
    [showRefreshBtn]="false"
  >
    <div before-btns>
      <!-- print btn -->
      <a
        class="btn btn-light txt-lg button-shadow tw-mx-1 text-blue btn-hover-rise d-print-none"
        mat-ripple
        [matTooltip]="'common.print' | translate"
        (click)="onPrint()"
      >
        <i class="mdi mdi-printer mdi-20px tw-p-0 text-blue"></i>
      </a>
    </div>
  </app-page-header>

  <div class="app-page-content">
    <div class="row">
      <div
        class="tw-mb-2 md:tw-w-2/3 offset-md-2 smart-sms-details-table dark:tw-bg-[unset] tw-border dark:tw-border-dark-100 !tw-p-0 tw-mt-4 tw-relative table-responsive"
      >
        <table
          class="table table-striped-even table-head-custom table-vertical-center overflow-hidden"
        >
          <thead class="tw-border-b dark:tw-border-dark-100">
            <tr class="fw-bold fs-6 tw-text-gray-800">
              <th></th>
              <th>
                {{ "common.partCount" | translate }}
              </th>
              <th>
                {{ "common.smsCount" | translate }}
              </th>
              <th>
                {{ "common.status" | translate }}
              </th>
              <th>
                {{ "common.operator" | translate }}
              </th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngIf="!pageConfig.loading">
              <tr
                #row
                *ngFor="let item of items; let index = index"
                class="tw-py-2"
              >
                <td class="tw-pr-2 tw-text-center">{{ index + 1 }}</td>
                <!-- partsCount -->
                <td>
                  <td-value
                    copyToClipboard
                    [value]="item?.partsCount"
                    type="number"
                  ></td-value>
                </td>

                <!-- smsCount -->
                <td>
                  <td-value
                    copyToClipboard
                    [value]="item?.smsCount"
                    type="number"
                  ></td-value>
                </td>

                <!-- statisticsSendStatus -->
                <td style="max-width: 200px" class="tw-pl-2">
                  <span>
                    {{
                      item?.statisticsSendStatus
                        | enumToText : StatisticsSendStatusEnumValues
                    }}
                  </span>
                </td>

                <!-- mobile operator -->
                <td style="max-width: 200px" class="tw-pl-2">
                  <span>
                    {{
                      item?.mobileOperator
                        | enumToText : MobileOperatorEnumValues
                    }}
                  </span>
                </td>
              </tr>
            </ng-container>

            <!-- empty -->
            <ng-container *ngIf="items.length == 0">
              <tr>
                <td colspan="100">
                  <p
                    class="tw-text-center tw-text-gray-800 dark:tw-text-gray-200 tw-my-5 tw-text-xl tw-dir-rtl ltr:tw-dir-ltr"
                  >
                    {{ "common.empty" | translate }}
                  </p>
                </td>
              </tr>
            </ng-container>

            <tr class="tw-py-2 total-sum" *ngIf="items.length > 0">
              <td
                class="tw-text-center !tw-py-3 tw-text-gray-700 dark:tw-text-gray-300"
                colspan="1"
              >
                {{ "common.totalSum" | translate }}
              </td>
              <td
                class="tw-px-2 tw-text-center tw-text-gray-800 dark:tw-text-gray-200 tw-font-medium"
              >
                {{ totalPartsCount | numberSeparator }}
              </td>
              <td
                class="tw-px-2 tw-text-center tw-text-gray-800 dark:tw-text-gray-200 tw-font-medium"
              >
                {{ totalSmsCount | numberSeparator }}
              </td>
              <td class="tw-text-center" [attr.colspan]="10"></td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="tw-w-full" *ngIf="items.length > 0">
        <div class="row">
          <div class="md:tw-w-1/2">
            <app-doughnut-chart-send-details-stats
              [StatisticsSendStatusEnumValues]="StatisticsSendStatusEnumValues"
              chartId="doughnut-send-details-stats"
              [model]="items"
            ></app-doughnut-chart-send-details-stats>
          </div>
          <div class="md:tw-w-1/2">
            <app-bar-chart-send-details-stats
              chartId="bar-send-details-stats"
              [model]="barChartItems"
              [dateType]="dateType"
              [PersianMonthEnumValues]="PersianMonthEnumValues"
              [StatisticsSendStatusEnumValues]="StatisticsSendStatusEnumValues"
            >
            </app-bar-chart-send-details-stats>
          </div>
        </div>
      </div>
    </div>
  </div>
</app-page-body>
